import { useEffect, useState } from "react";
import { Button, FormControl, Menu, TextareaAutosize } from "@mui/material";
import { Input } from "@100mslive/roomkit-react";
import { CheckMark } from "../../../icons";
import FullPageProgress from "../../FullPageProgress";
import { ToastManager } from "../../Toast/ToastManager";
import { isValidEmail } from "../../../common/utils";
import { OTHER_SERVICES } from "../../../services";

const EventHeaderFeedback = props => {
  const { userData } = props;
  const [headerOrgEl, setHeaderOrgEl] = useState(null);
  const headerOrgOpen = Boolean(headerOrgEl);
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);
  const headerOrgMenuOpen = event => {
    setHeaderOrgEl(event.currentTarget);
  };
  const headerOrgMenuClose = () => {
    setHeaderOrgEl(null);
  };

  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");

  const saveForm = async () => {
    if (!email || !isValidEmail(email)) {
      ToastManager.addToast({ title: "Please enter your email to continue" });
      return false;
    } else if (!message?.trim()) {
      ToastManager.addToast({
        title: "Please enter your feedback to continue",
      });
      return false;
    }

    setLoading(true);

    OTHER_SERVICES.feedback({
      email: email,
      message: message,
      url: window.location.href,
    })
      .then(data => {
        setLoading(false);
        if (data.code === 200) {
          setSent(true);
          setMessage("");
          headerOrgMenuClose();
        } else {
          ToastManager.addToast({ title: data?.message });
        }
      })
      .catch(err => {
        ToastManager.addToast({ title: err?.message });
      })
      .finally(() => {
        setLoading(false);
      });
  };

  useEffect(() => {
    if (sent) {
      setTimeout(function () {
        setSent(false);
      }, 3000);
    }
  }, [sent]);
  useEffect(() => {
    if (userData) {
      setEmail(userData?.email);
    }
  }, [userData]);

  return (
    <div className="events6ix-layout-header-right-item">
      {sent ? (
        <Button
          variant="outlined"
          className="events6ix-btn events6ix-btn-light events6ix-btn-sm"
          disabled
          startIcon={<CheckMark green />}
          size="small"
        >
          Sent
        </Button>
      ) : (
        <div
          className={`events6ix-layout-header-right-item-btn events6ix-layout-header-right-item-btn-full ${
            headerOrgOpen ? "active" : ""
          } `}
          id="header-feeback-menu-button"
          aria-controls={headerOrgOpen ? "header-feedback-menu" : undefined}
          aria-haspopup="true"
          aria-expanded={headerOrgOpen ? "true" : undefined}
          onClick={headerOrgMenuOpen}
        >
          Feedback
        </div>
      )}

      <Menu
        id="header-feedback-menu"
        anchorEl={headerOrgEl}
        open={headerOrgOpen}
        onClose={headerOrgMenuClose}
        MenuListProps={{
          "aria-labelledby": "header-feeback-menu-button",
        }}
        className="events6ix-layout-header-right-item-dropdown events6ix-layout-header-right-item-dropdown-feedback"
      >
        <div className="events6ix-layout-header-right-item-dropdown-feedback-inner">
          {!userData ? (
            <FormControl className="custom-form-group">
              <label
                htmlFor="header-feedback-email"
                className="custom-form-label big-label"
              >
                Email
              </label>
              <Input
                id="header-feedback-email"
                placeholder="Your email"
                name="email"
                type="email"
                className="custom-form-input"
                value={email}
                onChange={e =>
                  setEmail(e.target?.value?.replace(/(<([^>]+)>)/gi, ""))
                }
              />
            </FormControl>
          ) : null}

          <FormControl className="custom-form-group">
            <TextareaAutosize
              id="header-feedback-msg"
              name="bio"
              value={message}
              placeholder="Your feedback..."
              onChange={e =>
                setMessage(e.target?.value?.replace(/(<([^>]+)>)/gi, ""))
              }
              className="custom-form-input"
              minRows={4}
              maxRows={4}
            />
          </FormControl>

          <Button
            color="primary"
            variant="outlined"
            className="events6ix-btn events6ix-btn-primary w-100"
            onClick={saveForm}
            disabled={loading}
          >
            Send
          </Button>
        </div>
      </Menu>

      {loading && <FullPageProgress fixed={true} />}
    </div>
  );
};

export default EventHeaderFeedback;
